export default import.meta.ROLLUP_FILE_URL_fHL9K7fYgzRFl_KEqeeRZQ